import { useCallback } from 'react';
import { useToastStore } from '../../stores/useToastStore';

export function useToast() {

    const showToast = useToastStore(state => state.showToast);

    const success = useCallback((message) => {
        showToast({
            type: 'success',
            message
        });
    }, [showToast]);

    const error = useCallback((message) => {
        showToast({
            type: 'error',
            message
        });
    }, [showToast]);

    const warning = useCallback((message) => {
        showToast({
            type: 'warning',
            message
        });
    }, [showToast]);

    const info = useCallback((message) => {
        showToast({
            type: 'info',
            message
        });
    }, [showToast]);

    return {
        success,
        error,
        warning,
        info
    };

}